function i(i){return i?{"privy-ui":"t"}:void 0}export{i as getUiHeader};
